<div class="flex items-center justify-between px-6 py-2 border-b border-slate-100 dark:border-slate-800/60 bg-white/50 dark:bg-slate-900/50">
  <div class="flex items-center gap-2">
    <p-breadcrumb [model]="items" styleClass="border-none bg-transparent p-0 text-sm"></p-breadcrumb>
  </div>
  <div class="flex items-center gap-3 text-sm text-slate-600 dark:text-slate-400">
    @if (company) {
      <span class="font-medium">{{ company.businessName }}</span>
    }
  </div>
</div>